import React from 'react';
import { Banner } from '@shopify/polaris';

interface ApiErrorBannerProps {
  error: string | null;
  onDismiss?: () => void;
  onRetry?: () => void;
  title?: string;
  tone?: 'critical' | 'warning' | 'info';
  showRetry?: boolean;
}

const ApiErrorBanner: React.FC<ApiErrorBannerProps> = ({
  error,
  onDismiss,
  onRetry,
  title = 'Error',
  tone = 'critical',
  showRetry = false,
}) => {
  if (!error) return null;

  const action = onRetry && showRetry ? {
    content: 'Retry',
    onAction: onRetry,
  } : undefined;

  return (
    <Banner
      title={title}
      tone={tone}
      onDismiss={onDismiss}
      action={action}
    >
      {error}
    </Banner>
  );
};

export default ApiErrorBanner;
